var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3"},[(_vm.explain !== 'Đang bổ sung giải thích cho câu trả lời.')?_c('div',{staticClass:"border rounded bg-light p-3",domProps:{"innerHTML":_vm._s(_vm.explain.replace('%link', `<a href='/goi-cuoc'>Nâng cấp tài khoản ngay !</a>`))}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }